import React, {useState} from 'react';
import {translations} from '../translations';

const Pricing = ({language}) => {
    const [hoveredPlan, setHoveredPlan] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [formData, setFormData] = useState({
        tenantName: '',
        phone: '',
        email: '',
        employees: 0,
        firstName: '',
        lastName: '',
        subscriptionModeCode: '',
        language: language // Add language from props
    });

    const pricingPlans = [
        {
            id: 0,
            subscriptionModeCode: 'free',
            nameKey: 'pricing.0.plan',
            price: '0',
            features: [
                'pricing.0.features.1',
                'pricing.0.features.2',
                'pricing.0.features.3',
                'pricing.0.features.4',
            ],
            ctaKey: 'pricing.cta',
            featured: false
        },
        {
            id: 1,
            subscriptionModeCode: 'entry-level',
            nameKey: 'pricing.1.plan',
            price: '499',
            features: [
                'pricing.1.features.1',
                'pricing.1.features.2',
                'pricing.1.features.3',
                'pricing.1.features.4',
                'pricing.1.features.5',
                'pricing.1.features.6'
            ],
            ctaKey: 'pricing.cta',
            featured: false
        },
        {
            id: 2,
            subscriptionModeCode: 'professional',
            nameKey: 'pricing.2.plan',
            price: '1,299',
            features: [
                'pricing.2.features.1',
                'pricing.2.features.2',
                'pricing.2.features.3',
                'pricing.2.features.4',
                'pricing.2.features.5',
                'pricing.2.features.6',
                'pricing.2.features.7',
            ],
            ctaKey: 'pricing.cta',
            featured: true
        },
        {
            id: 3,
            subscriptionModeCode: 'enterprise',
            nameKey: 'pricing.3.plan',
            price: translations[language]['pricing.3.price'],
            features: [
                'pricing.3.features.1',
                'pricing.3.features.2',
                'pricing.3.features.3',
                'pricing.3.features.4',
                'pricing.3.features.5',
                'pricing.3.features.6',
                'pricing.3.features.7',
                "pricing.3.features.8"
            ],
            ctaKey: 'pricing.contact',
            featured: false
        }
    ];

    const handlePlanClick = (plan) => {
        setSelectedPlan(plan);
        setFormData(prev => ({
            ...prev,
            subscriptionModeCode: plan.subscriptionModeCode,
            planName: translations[language][plan.nameKey],
            language: language // Ensure language is included
        }));
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'employees' ? parseInt(value) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/gw/tenant/apply-order/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Tenant-ID': 'default'
                },
                body: JSON.stringify(formData),
            });
            const responseData = await response.json().catch(() => ({})); // Safely parse JSON
            debugger

            if (response.ok && (!responseData?.code || responseData?.code === "0")) {
                alert(translations[language]['form.apply.success']);
                setShowForm(false);
            } else {
                const errorMessage = responseData.description || translations[language]['form.error'];
                alert(errorMessage);
            }
        } catch (error) {
            debugger
            alert(translations[language]['form.error']);
            console.error('Error submitting form:', error);
        }
    };

    return (
        <section className="pricing" id="pricing">
            <div className="section-title">
                <h3 className="chinese-font">{translations[language]['pricing.title']}</h3>
                <p className="chinese-font">{translations[language]['pricing.subtitle']}</p>
            </div>
            <div className="pricing-grid">
                {pricingPlans.map((plan) => (
                    <div
                        className={`pricing-card ${plan.id ? '1' : ''} ${hoveredPlan === plan.id ? 'hovered' : ''}`}
                        key={plan.id}
                        onMouseEnter={() => setHoveredPlan(plan.id)}
                        onMouseLeave={() => setHoveredPlan(null)}
                    >
                        {/*{plan.featured && (*/}
                        {/*    <div className="featured-badge">{translations[language]['pricing.featured']}</div>*/}
                        {/*)}*/}
                        <h4 className="chinese-font">{translations[language][plan.nameKey]}</h4>
                        <div className="price">
                            {plan.price}<span>{translations[language]['pricing.month']}</span>
                        </div>
                        <ul className="pricing-features">
                            {plan.features.map((featureKey, idx) => (
                                <li className="chinese-font" key={idx}>
                                    {translations[language][featureKey]}
                                </li>
                            ))}
                        </ul>
                        <button
                            className={`btn 'btn-secondary'} ${hoveredPlan === plan.id ? 'btn-hover' : ''}`}
                            onClick={() => handlePlanClick(plan)}
                            disabled={plan.id === 1 || plan.id === 2}
                        >
                            {plan.id === 1 || plan.id === 2
                                ? translations[language]['pricing.comingSoon']
                                : translations[language][plan.ctaKey]}
                        </button>

                    </div>
                ))}
            </div>

            {showForm && (
                <div className="form-modal">
                    <div className="modal-content">
                        <button className="close-btn" onClick={() => setShowForm(false)}>
                            &times;
                        </button>
                        <h3>{translations[language][selectedPlan?.nameKey]}</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>{translations[language]['form.firstName']}</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations[language]['form.lastName']}</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations[language]['form.tenantName']}</label>
                                <input
                                    type="text"
                                    name="tenantName"
                                    value={formData.tenantName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations[language]['form.email']}</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations[language]['form.phone']}</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations[language]['form.employees']}</label>
                                <input
                                    type="number"
                                    name="employees"
                                    value={formData.employees}
                                    onChange={handleInputChange}
                                    min="1"
                                    required
                                />
                            </div>
                            <input type="hidden" name="subscriptionModeCode" value={formData.subscriptionModeCode}/>
                            <button type="submit" className="btn btn-primary">
                                {translations[language]['form.submit']}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <style jsx>{`
                .pricing

                -
                grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 20px;
                    margin-top: 30px;
                }

                .pricing-card {
                    background: white;
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                    position: relative;
                    transition: transform 0.3s ease;
                }

                .pricing-card.featured {
                    border: 2px solid #4CAF50;
                }

                .pricing-card.hovered {
                    transform: translateY(-5px);
                }

                .featured-badge {
                    position: absolute;
                    top: -10px;
                    right: 20px;
                    background: #4CAF50;
                    color: white;
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-size: 12px;
                }

                .price {
                    font-size: 2rem;
                    font-weight: bold;
                    margin: 15px 0;
                }

                .price span {
                    font-size: 1rem;
                    font-weight: normal;
                    color: #666;
                }

                .pricing-features {
                    list-style: none;
                    padding: 0;
                    margin: 20px 0;
                }

                .pricing-features li {
                    padding: 5px 0;
                }

                .form-modal {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }

                .modal-content {
                    background: white;
                    padding: 2rem;
                    border-radius: 8px;
                    width: 100%;
                    max-width: 500px;
                    position: relative;
                }

                .close-btn {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    cursor: pointer;
                }

                .form-group {
                    margin-bottom: 1rem;
                }

                .form-group label {
                    display: block;
                    margin-bottom: 0.5rem;
                }

                .form-group input {
                    width: 100%;
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }

                .btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            `}</style>
        </section>
    );
};

export default Pricing;
